export default __webpack_public_path__ + "static/media/gallery-wip-handle-neck_02.d649f899.jpg";